import CardImagen from './components/CardImg';
import heroStudents from '../../assets/img/formacion-tecnico-laboral/hero-students.jpg';
import './FormacionTecnica.css';

const beneficios = [
  {
    icono: '✦',
    texto: 'Programas certificados y avalados',
  },
  {
    icono: '♙',
    texto: 'Docentes con experiencia en el sector salud',
  },
  {
    icono: '▣',
    texto: 'Formación práctica y pertinente',
  },
  {
    icono: '↗',
    texto: 'Mejores oportunidades laborales',
  },
];

const FormacionTecnicoLaboral = () => {
  return ( 
    <main className="formacion-page">
      <section className="formacion-hero">
        <div className="hero-copy">
          <p className="hero-eyebrow">Oferta académica</p>
          <h1>
            Programas que impulsan
            <span>tu futuro profesional</span>
          </h1>
          <span className="red-line"></span>
          <p className="hero-description">
            Formación técnica laboral de calidad, diseñada para brindarte las habilidades que el mundo laboral necesita.
          </p>
          <a className="hero-button" href="#programas">
            ◈ Conoce nuestros programas
          </a>
        </div>

        <div className="hero-visual" aria-hidden="true">
          <img src={heroStudents} alt="" />
        </div>
      </section>

      <section className="beneficios-bar" aria-label="Beneficios de la oferta académica">
        {beneficios.map((beneficio) => (
          <article className="beneficio-item" key={beneficio.texto}>
            <span className="beneficio-icono">{beneficio.icono}</span>
            <h2>{beneficio.texto}</h2>
          </article>
        ))}
      </section>

      <CardImagen />
    </main>
  );
};

export default FormacionTecnicoLaboral;
